const mediaRowSm = `
	flex-direction: column;
	align-items: flex-start;
	gap: 5px;
	margin-bottom: 10px;
`;

const widthRow = `width: 100%;`;

export { mediaRowSm, widthRow };
